import { Panel, PanelState } from "../Panel/Panel";
import * as PIXI from "pixi.js";
import { observer } from "src/shared/util/Observer";
import { SpinResponse } from "src/shared/util/Types";
import { GameState, GlobalState } from "src/shared/util/GlobalState";
import { UI, UIEvent } from "src/shared/UI/UI";
import { GameEngine } from "../server/GameEngine";
import { GameAssets } from "src/shared/util/GameAssets";
import gsap from "gsap";
import AppSingleton from "src/shared/util/AppSingleton";

export class GameView extends PIXI.Container {
  private app: PIXI.Application<PIXI.Renderer>;

  private content: PIXI.Container;
  private background: PIXI.Sprite;
  private fsBackground: PIXI.Sprite;
  private panel: Panel;
  private UI!: UI;
  private response!: SpinResponse;
  private gameState: GameState = GameState.MAIN;
  private timeline!: gsap.core.Timeline | null;

  constructor() {
    super();

    observer.on('gameActionResponse', this.onSpinResponse.bind(this));

    this.app = AppSingleton.getInstance().app;
    this.app.stage.on('resize', this.resize, this);

    window.addEventListener('keydown', this.handleKeyDown.bind(this));

    this.content = new PIXI.Container();
    this.addChild(this.content);

    this.background = new PIXI.Sprite(GameAssets.textures.mainBg);
    this.background.anchor.set(0.5);

    this.fsBackground = new PIXI.Sprite(GameAssets.textures.fsBg);
    this.fsBackground.anchor.set(0.5);
    this.fsBackground.visible = false;

    this.panel = new Panel();
    this.panel.zIndex = 3;
    this.panel.on(PanelState.IDLE, this.onPanelIdle, this);
    this.panel.on(PanelState.CASCADE, this.onCascade, this);
    this.panel.on('resetQuickStop', this.onResetQuickStop, this);
    this.panel.on('showRandomWilds', this.zoomIn, this);

    this.UI = new UI();
    this.UI.on('spin', this.onSpin, this);
    this.UI.on('stop', this.onQuickStop, this);
    this.UI.updateVisualBalance();
    this.UI.setWin(0);
    this.UI.resetSpinButton();

    this.addComponentsOnStage();

    // this.UI.lock();
    // this.UI.hideBar();
    // this.UI.once(UIEvent.SCREEN_CLICK, this.onIntroClick.bind(this));

    this.content.visible = true;
    this.UI.resetSpinButton();
    this.UI.showBar();
    this.panel.init(GameEngine.getInstance().getLoadResponse());
  }

  onPortrait(data: any) {
    this.background.scale.set(2.4);
    this.fsBackground.scale.set(2.4);
    this.background.y = -600;
    this.fsBackground.y = -600;

    this.panel.onPortrait(data);
  }

  onLandscape(data: any) {
    this.background.scale.set(1.1);
    this.background.y = -80;
    this.fsBackground.scale.set(1.1);
    this.fsBackground.y = -80;

    this.panel.onLandscape(data);
  }

  addComponentsOnStage() {
    this.content.addChild(this.background);
    this.content.addChild(this.fsBackground);
    this.content.addChild(this.panel);
    this.addChild(this.UI);
  }

  handleKeyDown(event: any) {
    switch (event.code) {
    }
  }

  async onPanelIdle() {
    switch (GlobalState.getInstance().state) {
      case GameState.MAIN:
        this.UI.setWin(this.response.totalWin);
        this.UI.updateVisualBalance();
        this.UI.resetSpinButton();
        break;
    }
  }

  onResetQuickStop() {
    this.UI.setStopButton();
  }

  onCascade() {
    if (GlobalState.getInstance().state === GameState.BONUS && this.response.totalWin) {
      this.UI.setWin(this.response.totalWin);
    } else {
      this.UI.setWin(this.response.roundWin);
    }
    GameEngine.getInstance().gameActionRequest();
  }

  async onSpin() {
    switch (GlobalState.getInstance().state) {
      case GameState.MAIN:
      case GameState.MAIN_TO_BONUS:
      case GameState.BONUS_TO_MAIN:
      case GameState.BONUS:
        GameEngine.getInstance().gameActionRequest();
        this.startSpin();
        this.UI.setWin(0);
        break;
    }
  }

  async onSpinResponse(response: SpinResponse) {
    this.response = response;
    this.panel.setData(this.response);
  }

  private zoomIn() {
    this.timeline = gsap.timeline()
      .to(this.content.scale, {
        x: 1.1,
        y: 1.1,
        duration: 2,
        ease: "power2.out",
      }).to(this.content.scale, {
        x: 1,
        y: 1,
        duration: 1,
        ease: "power2.out",
      });
  }

  private onQuickStop() {
    switch (GlobalState.getInstance().state) {
      case GameState.MAIN_TO_BONUS:
      case GameState.BONUS_TO_MAIN:
      case GameState.MAIN:
      case GameState.BONUS:
        // Stop and kill the existing timeline if it exists
        if (this.timeline) {
          this.timeline.kill();
          this.content.scale.set(1, 1);
          this.timeline = null; // Clear reference
        }
        this.panel.quickStop();
        break;
    }
  }

  private resize(data: any) {
    if (data.ratio < 1.4) {
      this.onPortrait(data);
    } else {
      this.onLandscape(data);
    }
  }
  private startSpin(isBuy: boolean = false) {
    if (this.panel.getState() === PanelState.IDLE) {
      GlobalState.getInstance().updateState({ balance: GlobalState.getInstance().balance - GlobalState.getInstance().bet });
      this.UI.updateVisualBalance();
      this.panel.spin();
    }
  }
}
